var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-20"},[_c('sss-header'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('footer',{staticClass:"mt-4 pt-4 border-t border-muted-300 dark:border-muted-600"},[_c('color-switcher')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }